import React, { useEffect, useRef } from "react";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";

const InstagramPost = ({ postUrl = "" }) => {
  const containerRef = useRef(null);

  useEffect(() => {
    if (window.instgrm) {
      window.instgrm.Embeds.process();
    }
  }, [postUrl]);

  return (
    <div
      ref={containerRef}
      className="w-full h-full relative flex items-center justify-center mt-1"
    >
      {/* <blockquote
        className="instagram-media"
        data-instgrm-permalink={postUrl}
        data-instgrm-version="14"
        style={{ maxWidth: "100%", height: "100%" }}
      ></blockquote> */}
        <img
          src={
            "https://www.creativefabrica.com/wp-content/uploads/2021/01/18/video-instagram-icon-template-logo-Graphics-7862331-1.jpg"
          }
          alt="Instagram preview"
          className="w-full h-full object-cover rounded-lg"
        />
      <div className="absolute text-white inset-0 flex flex-col items-center justify-center bg-black bg-opacity-0 rounded-lg">
        <a
          href={postUrl || "#"}
          rel="noopener noreferrer"
          target="_blank"
          className="w-16 h-16 bg-black bg-opacity-30 rounded-full transition duration-300 hover:bg-opacity-50"
        >
          <svg
            width="64"
            height="64"
            viewBox="0 0 72 72"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle
              cx="35.7789"
              cy="35.9322"
              r="34.5428"
              stroke="white"
              strokeWidth="2.4"
            />
            <path
              d="M52.3914 32.8145C54.7914 34.2002 54.7914 37.6643 52.3914 39.0499L30.1723 51.8781C27.7723 53.2638 24.7723 51.5317 24.7723 48.7604L24.7723 23.1041C24.7723 20.3328 27.7723 18.6007 30.1723 19.9864L52.3914 32.8145Z"
              stroke="white"
              strokeWidth="2.4"
            />
          </svg>
        </a>
        <span className="text-sm lg:text:lg mt-2 font-dmserif">
          Virtual Tour Preview
        </span>
      </div>
    </div>
  );
};

export default InstagramPost;
